import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PicklistService {

  constructor() { }
  printPickList(batchData:any):any{
    const groupedMedications: {
      [medicationName: string]: {
        prescriptionIds: string[];
        quantity: number;
        medicationId: string;
      };
    } = {};
    if(batchData != null){
      batchData.prescriptions.forEach((prescription: any) => {
        prescription.medications.forEach((medication: any) => {
          if (groupedMedications[medication.medicationName]) {
            groupedMedications[medication.medicationName].prescriptionIds.push(
              prescription.rxId
            );
            groupedMedications[medication.medicationName].quantity += 1;
          } else {
            groupedMedications[medication.medicationName] = {
              prescriptionIds: [prescription.rxId],
              quantity: 1,
              medicationId: medication.medicationId,
            };
          }
        });
      });
    }
    return groupedMedications;
  }
}